// extracted by mini-css-extract-plugin
export default {"label":"Datepicker_label__UZO6Q","input":"Datepicker_input__igBgV","calendarIcon":"Datepicker_calendarIcon__4OucJ","clearIcon":"Datepicker_clearIcon__bcVZb"};